import { array, option } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { SettlementRuleResult, SettlementValueType, useRepositoryQuery } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { Option, WithEnterpriseId } from '@mews-commander/types';
import { useGetSettlementRuleName } from '../../../../../components';

interface Params extends WithEnterpriseId {
    settlementCurrencyCode?: string;
}

export const useLocalPaymentPolicyOptions = ({ enterpriseId, settlementCurrencyCode }: Params) => {
    const getSettlementRuleName = useGetSettlementRuleName();
    return useRepositoryQuery(
        'settlementRules',
        'getAll',
        { enterpriseId },
        {
            select: flow(
                (result: SettlementRuleResult[] | undefined) => option.fromNullable(result),
                option.map((result) =>
                    pipe(
                        result,
                        array.filterMap((settlementRule) => {
                            const { discriminator, value } = settlementRule.value;

                            if (
                                settlementCurrencyCode &&
                                discriminator === SettlementValueType.Flat &&
                                value.currencyCode !== settlementCurrencyCode
                            ) {
                                return option.none;
                            }

                            const parameters = getSettlementRuleName(settlementRule, { format: 'parameters' });

                            return option.some(
                                createOption({
                                    value: settlementRule.id,
                                    label: settlementRule.name || parameters,
                                    secondaryText: settlementRule.name ? parameters : null,
                                })
                            );
                        })
                    )
                ),
                option.getOrElse(() => [] as Option[])
            ),
        }
    );
};
